"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonTypes = exports.buttonThemes = exports.widthRatio = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box-container"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box"));

var _gerenciatdReact3 = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.tagging-utils");

require("./Button.scss");

require("@bit/gerenciatd.react.store-scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widthRatio = {
  REDUCED: 'Reduced',
  DEFAULT: 'Default',
  SIMPLE: 'Simple',
  DOUBLE: 'Double'
};
exports.widthRatio = widthRatio;
var buttonThemes = {
  GREEN: 'Green',
  RED: 'Red',
  BLUE: 'Blue',
  MUSTARD: 'Mustard',
  HEADER: 'Header'
};
exports.buttonThemes = buttonThemes;
var buttonTypes = {
  SOFT: 'Soft',
  SOLID: 'Solid',
  TRANSPARENT: 'Transparent'
};
/**
 * Stateless component to draw a card.
 * @param {string} label Label on the button.
 * @param {string} wrapperClass css class
 * @param {bool} type Sets button type (buttonTypes).
 * @param {string} theme Sets the theme of the button (buttonThemes).
 * @param {bool} visible Sets if the button is visible.
 * @param {string} link Sets the link of the button .
 * @param {func} onClick Executed function by clicking the button.
 * @param {string} taggingType type of button tagging.
 * @param {string} id Button id, used for tagging.
 * @returns {JSX} Component JSX.
 */

exports.buttonTypes = buttonTypes;

var Button = function Button(_ref) {
  var type = _ref.type,
      theme = _ref.theme,
      label = _ref.label,
      visible = _ref.visible,
      disable = _ref.disable,
      link = _ref.link,
      widthRatio = _ref.widthRatio,
      onClick = _ref.onClick,
      wrapperClass = _ref.wrapperClass,
      managementValue = _ref.managementValue,
      id = _ref.id,
      loading = _ref.loading,
      iconClass = _ref.iconClass,
      buttonType = _ref.buttonType;
  var typeOfButton = buttonType;

  if (buttonType !== 'submit' && buttonType !== 'reset' && buttonType !== 'button') {
    typeOfButton = 'submit';
  }

  var buttonOnClick = function buttonOnClick() {
    var taggingType = 'boton';

    if (onClick && !disable) {
      (0, _gerenciatdUtils.sendTagging)(taggingType, id, managementValue);
      onClick();
    }
  };

  var disableButton = disable || loading ? 'disable' : '';

  if (visible) {
    if (link) {
      if (disableButton === 'disable' && process.env.NODE_ENV === 'development') {
        console.warn('disable or loading prop dont make sense when link is present');
      }

      return _react.default.createElement("div", {
        className: "button ".concat(wrapperClass)
      }, _react.default.createElement("div", {
        className: "btn width".concat(widthRatio, " type").concat(type, " theme").concat(theme, " ").concat(disableButton)
      }, _react.default.createElement(_gerenciatdReact.default, null, _react.default.createElement(_gerenciatdReact2.default, {
        managementValue: managementValue,
        id: id,
        onClick: onClick,
        link: link,
        label: label,
        component: "boton"
      }, _react.default.createElement("span", {
        class: "buttonLabel"
      }, label), iconClass && _react.default.createElement(_gerenciatdReact3.default, {
        classIcon: iconClass,
        wrapperClass: "iconButton"
      })))));
    }

    return _react.default.createElement("div", {
      className: "button ".concat(wrapperClass)
    }, _react.default.createElement("button", {
      id: id,
      type: typeOfButton,
      onClick: buttonOnClick,
      className: "btn width".concat(widthRatio, " type").concat(type, " theme").concat(theme, " ").concat(disableButton)
    }, loading && _react.default.createElement("span", null, _react.default.createElement(_reactLoaderSpinner.default, {
      type: "TailSpin",
      color: theme === 'Solid' ? 'white' : '#989a9e',
      height: 30,
      width: 30
    })), !loading && _react.default.createElement(_react.Fragment, null, _react.default.createElement("span", null, label), iconClass && _react.default.createElement(_gerenciatdReact3.default, {
      classIcon: iconClass,
      wrapperClass: "iconButton"
    }))));
  }

  return null;
};

Button.propTypes = {
  label: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  theme: _propTypes.default.string.isRequired,
  visible: _propTypes.default.bool,
  link: _propTypes.default.string,
  wrapperClass: _propTypes.default.string,
  id: _propTypes.default.string,
  loading: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  widthRatio: _propTypes.default.oneOf([widthRatio.DOUBLE, widthRatio.REDUCED, widthRatio.SIMPLE]),
  buttonType: _propTypes.default.string
};
Button.defaultProps = {
  type: 'Solid',
  visible: true,
  link: null,
  wrapperClass: '',
  id: '',
  widthRatio: widthRatio.DEFAULT,
  loading: false,
  onClick: function onClick() {},
  buttonType: 'submit'
};
var _default = Button;
exports.default = _default;

//# sourceMappingURL=index.js.map